import { Page } from '../../../../components/page/page';
import { DeleteModal } from '../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../features/has-access/has-access';
import { RestoreModal } from '../../../../features/restore-modal/restore-modal';
import { PromoCards } from './promo-cards/promo-cards';
import { PromoControls } from './promo-controls/promo-controls';
import s from './promo-list.module.css';
import { PromoTable } from './promo-table/promo-table';
import { usePromoList } from './use-promo-list';

export const PromoList = () => {
  const { t, restorePromo, deletePromo, viewStyle, list } = usePromoList();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>
        {`${t('Акции')} ${list?.length ? `(${list.length})` : ''}`}
        <PromoControls />
      </h2>
      {viewStyle === 'table' ? <PromoTable /> : <PromoCards />}

      <HasAccess service="promotion" permissions={['write']}>
        <RestoreModal onSubmit={restorePromo} />
        <DeleteModal onSubmit={deletePromo} />
      </HasAccess>
    </Page>
  );
};
